module.exports = __webpack_public_path__ + "static/media/intro_lifestyle_desktop.6170c3a1.webp";